// Copyright © 2006-2020 Lexbe Inc. All rights reserved.

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from './app-config.service';
import { PagingResponse } from '@models/paging-response.model';
import { ErrorHandlerService } from './error-handler.service';
import { CaseContact } from '../models/case-contact.model';

@Injectable({
	providedIn: 'root'
})
export class CaseContactService {

	constructor(private http: HttpClient, private errorHandler: ErrorHandlerService, private appConfigService: AppConfigService) { }

	public getContacts(searchTerm?: string): Observable<PagingResponse<CaseContact>> {
		const requestParams = searchTerm ? new HttpParams().set('$search', `${searchTerm.toLowerCase()}`) : new HttpParams();

		return this.http.get<PagingResponse<CaseContact>>(`${this.appConfigService.getConfig().webApi}/api2/CaseContacts`, { params: requestParams });
	}

	public addContact(contact: CaseContact): Observable<CaseContact> {
		return this.http.post<CaseContact>(`${this.appConfigService.getConfig().webApi}/api2/CaseContacts`, contact).pipe(
			catchError(this.errorHandler.handleError<CaseContact>(`[POST] CaseContacts failed for ContactId=${contact.contactId}`)));
	}

	public getContactAffiliation(): Observable<string[]> {
		return this.http.get<string[]>(`${this.appConfigService.getConfig().webApi}/api2/CaseContacts/Affiliation`)
			.pipe(catchError(this.errorHandler.handleError<string[]>(`get contact affiliation`)));
	}

	public updateContact(contactId: string, contactDelta): Observable<void> {
		const body = [];
		for (const key in contactDelta) {
			body.push({
				op: "replace",
				path: `/${key}`,
				value: contactDelta[key]
			});
		}
		return this.http.patch<void>(`${this.appConfigService.getConfig().webApi}/api2/CaseContacts/${contactId}`, body).pipe(
			catchError(this.errorHandler.handleError<void>(`[PATCH] CaseContacts failed for ContactId=${contactId}`)))
	}

	public deleteContact(contactId: string): Observable<void> {
		return this.http.delete<void>(`${this.appConfigService.getConfig().webApi}/api2/CaseContacts/${contactId}`).pipe(
			catchError(this.errorHandler.handleError<void>(`[DELETE] CaseContacts failed for ContactId=${contactId}`)));
	}
}
